/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedBusinessSectorDropdown200,
  GetApiV1PersonSharedBusinessSectorDropdown401,
  GetApiV1PersonSharedBusinessSectorDropdown500,
  GetApiV1PersonSharedBusinessSectorDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedBusinessSectorDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedBusinessSectorDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1PersonSharedBusinessSectorDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedBusinessSectorDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedBusinessSectorDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedBusinessSectorDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedBusinessSectorDropdown500>;

export const getApiV1PersonSharedBusinessSectorDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedBusinessSectorDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedBusinessSectorDropdownQueryResponse>;
